<template>
  <div id="app">
    <transition name="pageloader">
      <div v-if="isLoading || waiting" class="splash">
        <!-- <vue-loading type="spin" color="#333" :size="{ width: '150px', height: '150px' }"></vue-loading> -->
        <!-- <span class="icon-logo"></span> -->
        <splash />
      </div>
    </transition>

    <template v-if="!isLoading">

      <nav-menu
        :main="mainMenu['main-menu-' + localeSlug(this.$root.$i18n.locale)].menu_items"
        :sub="mainMenu['sub-menu-' + localeSlug(this.$root.$i18n.locale)].menu_items"
        :sns="mainMenu['sns-menu-' + localeSlug(this.$root.$i18n.locale)].menu_items"
        staticpath=""
        currentpath=""
      ></nav-menu>

      <main id="page-wrap">

        <header class="header">
          <div class="container">
            <div class="brand-id">
              <h1><router-link to="/"><img src="~@/assets/img_logo.svg"></router-link></h1>
            </div>
          </div>
          <portal-target name="guide-button-dest"></portal-target>
        </header>

        <div class="page">
          <router-view/>
          <div v-if="backButtonText" class="backButton button-base is-fixed">
            <router-link :to="backButtonDest" class="button is-danger is-full has-icon"><span class="icon icon-arrow_back"></span>{{backButtonText}}</router-link>
          </div>
          <footer class="footer">
            <p class="copyright" :style="'color: ' + footerTextColor">&copy; Copyright NACT. All rights reserved.</p>
          </footer>
        </div>

      </main>
    </template>

    <!-- {% block modal %}{% endblock modal %} -->
    <portal-target name="overray-dest" multiple></portal-target>
    <portal-target name="gallery-images" multiple></portal-target>
    <portal-target name="map-images" multiple></portal-target>
    <guide
      name="conicGuide"
      :steps="getGuide"
    >
    </guide>
  </div>
</template>

<script>
import _ from 'lodash'
import pluralize from 'pluralize'
import { mapGetters, mapActions } from 'vuex'
import NavMenu from './components/Menu.vue'
import Guide from './components/Guide.vue'
import Splash from './components/Splash.vue'
// import { VueLoading } from 'vue-loading-template'
import { localeHelper } from './i18n/index'

export default {
  components: {
    // VueLoading,
    NavMenu,
    Guide,
    Splash,
  },
  data() {
    return {
      waiting: true,
      routeOrigin: {
        name: 'route_home',
        path: '/',
      },
      backButtonText: '',
      backButtonDest: '',
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'getMenus',
      'getGuide',
      'fontSize',
      'footerTextColor',
    ]),
    mainMenu: function() {
      const menu = this.getMenus
      if(menu){
        return _.keyBy(this.getMenus.items, function(item) {
          return item.slug
        })
      }
      return null
    }
  },
  watch: {
    // watch the value of isLoading and once it's false hide the loader
    // isLoading(val) {
    //   if (val == false) {
    //     let self = this
    //     setTimeout(function(){
    //       self.showLoader = false
    //     }, 1)
    //   }
    // },
    $route (to, from){
        // window.removeEventListener('scroll', this.handleScroll)
        // this.curtainEffect()

        // console.log("this.$route.query is ", this.$route.query)
        // console.log("this.$route.query.ref is ", this.$route.query.ref)
        if(this.$route.query && this.$route.query.ref && this.$route.query.ref !== 'undefined'){
          this.routeOrigin.name = this.$i18n.t('route_' + this.$route.query.ref)
          this.routeOrigin.path = '/' + this.$route.query.ref + '/'
          if(this.$route.query.kwd && this.$route.query.kwd !== 'undefined'){
            this.routeOrigin.name = this.$i18n.t('route_' + pluralize.singular(this.$route.query.ref))
            this.routeOrigin.path += this.$route.query.kwd + '/'
          }
        } else {
          this.routeOrigin.name = this.$i18n.t('homepage')
          this.routeOrigin.path = '/'
        }

        // console.log('to', to)
        // console.log('from', from)
        this.switchBackButton(from, to)
    },
  },
  methods:{
    ...mapActions([
      'resetLoadingProgress',
      'setFooterTextColor',
      'setFontSize',
      'fetchSnippets',
      'fetchSpotList',
      'fetchTourList',
      'setGuideVisibility',
    ]),
    localeSlug: function (locale) {
      return localeHelper(locale)
    },
    switchBackButton: function(from, to) {
      if(to.name === 'home' || to.name === 'spots' || to.name === 'tours' || to.name === 'tour' || to.name === 'keywords' || to.name === 'locations'){
        this.backButtonText = ''
        this.backButtonDest = ''
        return false
      }
      if(from.name !== 'spot'){
        if(from.name && from.path) {
          this.routeOrigin.name = this.$i18n.t('route_' + from.name)
          this.routeOrigin.path = from.path
        }
      }

      if(this.$root.$i18n.locale === 'en'){
        this.backButtonText = 'Back to ' + this.$i18n.t(this.routeOrigin.name)
      } else if(this.$root.$i18n.locale === 'zh'){
        this.backButtonText = '返回' + this.$i18n.t(this.routeOrigin.name)
      } else if(this.$root.$i18n.locale === 'ko'){
        this.backButtonText = this.$i18n.t(this.routeOrigin.name) + ' 페이지로 이동'
      } else {
        this.backButtonText = this.$i18n.t(this.routeOrigin.name) + 'へ戻る'
      }

      this.backButtonDest = this.routeOrigin.path
    },
  },

  created(){
    this.resetLoadingProgress()

    this.fetchSnippets({ ep:'menus', lang:this.$root.$i18n.locale })
    // this.fetchSnippets({ ep:'keywords' })
    // this.fetchSnippets({ ep:'locations' })
    this.fetchSpotList({ lang:this.$root.$i18n.locale })
    this.fetchTourList({ lang:this.$root.$i18n.locale })

    this.setFooterTextColor('#000')
    this.setGuideVisibility(false)

    let textSize = this.fontSize
    this.$cookies.config('30d')
    if(this.$cookies.isKey('textSize')){
      textSize = this.$cookies.get('textSize')
    }
    this.$cookies.set('textSize', textSize);
    this.setFontSize({ size: textSize })
    document.documentElement.classList.add('text-size-' + textSize)
  },

  mounted(){
    setTimeout(() => {
      this.waiting = false
    }, 3000);
  },

}
</script>

<style lang="scss"></style>
